import { Map } from 'immutable';
import { getOrderDeadlinesForAccount, selectDeadline } from './actions';
import OrderWindow from './OrderWindow';

export const defaultState = Map({});

const orderDeadlines = (state = defaultState, action) => {
  switch (action.type) {
    case getOrderDeadlinesForAccount.event.success: {
      const { accountNumber, response } = action.payload;
      const deadlines = response.map(window => new OrderWindow(window));

      return state.set(accountNumber, deadlines).set('selected', deadlines[0] || null);
    }
    case getOrderDeadlinesForAccount.event.error: {
      const { accountNumber } = action.payload;

      return state.set(accountNumber, null).set('selected', null);
    }
    case selectDeadline.type:
      return state.set('selected', action.payload);
    default:
      return state;
  }
};

export const deadlinesForAccount = (state, accountNumber) => state.orderDeadlines.get(accountNumber);
export const getSelectedDeadline = state => state.orderDeadlines.get('selected');
export default orderDeadlines;
